import { useState, useEffect } from "react";
import { MOBILE_SCREEN_SIZE } from "src/constants/constants";

/**
 * Hook to detect whether the current screen width is at or below the mobile breakpoint.
 * @returns {boolean} - `true` if the screen width is <= MOBILE_SCREEN_SIZE, otherwise `false`.
 */
export default function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(
    window.innerWidth <= MOBILE_SCREEN_SIZE
  );

  useEffect(() => {
    const handleResize = (): void => {
      setIsMobile(window.innerWidth <= MOBILE_SCREEN_SIZE);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}
